// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"icon-avatar_avatarContainer__3Kxej","avatarIcon":"icon-avatar_avatarIcon__23G7N"};